import React from 'react';
import { useNavigate } from 'react-router-dom';
import { format, endOfWeek, eachDayOfInterval, getDate, isSameYear } from 'date-fns';
import Header from '../../components/ui/Header';

const WeekOverview = () => {
  const navigate = useNavigate();
  
  // Sample data - in real app this would come from props/context
  const currentYear = 2026;
  const weekNumber = 1;
  const weekStart = new Date(2025, 11, 28); // Dec 28, 2025
  const weekEnd = endOfWeek(weekStart, { weekStartsOn: 0 });
  
  const days = eachDayOfInterval({ start: weekStart, end: weekEnd });
  const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  
  // Format date range
  const startMonth = format(weekStart, 'MMM');
  const startDay = format(weekStart, 'd');
  const endMonth = format(weekEnd, 'MMM');
  const endDay = format(weekEnd, 'd');
  
  const dateRange = startMonth === endMonth 
    ? `${startMonth} ${startDay} - ${endDay}`
    : `${startMonth} ${startDay} - ${endMonth} ${endDay}`;
  
  const handlePreviousWeek = () => {
    // Navigate to previous week logic
    console.log('Navigate to previous week');
  };
  
  const handleNextWeek = () => {
    // Navigate to next week logic
    console.log('Navigate to next week');
  };
  
  const handleDayClick = (day) => {
    const isInPlannerYear = isSameYear(day, new Date(currentYear, 0, 1));
    if (isInPlannerYear) {
      // Navigate to daily schedule page
      console.log('Navigate to day:', day);
    }
  };

  const handleLogout = () => {
    // Handle logout logic
    console.log('Logout');
    navigate('/login');
  };
  
  return (
    <div className="min-h-screen bg-gray-50">
      <Header onLogout={handleLogout} />
      {/* Week Header */}
      <div className="max-w-6xl mx-auto px-4 py-6">
        <h1 className="text-3xl font-bold text-center text-gray-800 mb-8">
          Week {weekNumber} | {dateRange} | {currentYear}
        </h1>
        
        {/* 7 Day Sections */}
        <div className="space-y-4">
          {days?.map((day, index) => {
            const dayName = daysOfWeek?.[day?.getDay()];
            const dayOfMonth = getDate(day);
            const isWeekend = index === 0 || index === 6;
            const isInPlannerYear = isSameYear(day, new Date(currentYear, 0, 1));
            
            return (
              <div
                key={index}
                className={`bg-white rounded-lg shadow p-4 ${
                  isWeekend ? 'h-32' : 'h-64'
                } transition-all hover:shadow-md`}
              >
                {/* Day Header */}
                <div className="border-b pb-2 mb-3">
                  <button
                    onClick={() => handleDayClick(day)}
                    disabled={!isInPlannerYear}
                    className={`text-lg font-bold ${
                      isInPlannerYear 
                        ? 'text-blue-600 hover:text-blue-800 cursor-pointer' :'text-gray-400 cursor-not-allowed'
                    }`}
                  >
                    {dayName} | {dayOfMonth}
                  </button>
                </div>
                {/* Lines for notes */}
                <div className="space-y-3">
                  {Array.from({ length: isWeekend ? 3 : 7 })?.map((_, lineIndex) => (
                    <div key={lineIndex} className="border-b border-gray-200" />
                  ))}
                </div>
              </div>
            );
          })}
        </div>
        
        {/* Footer Navigation */}
        <div className="flex justify-between items-center mt-8 pt-6 border-t">
          <button
            onClick={handlePreviousWeek}
            className="flex items-center gap-2 px-4 py-2 text-blue-600 hover:text-blue-800 transition-colors"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Previous Week
          </button>
          
          <button
            onClick={handleNextWeek}
            className="flex items-center gap-2 px-4 py-2 text-blue-600 hover:text-blue-800 transition-colors"
          >
            Next Week
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default WeekOverview;